import { useEffect, useState } from 'react';
import type { TierLimits } from '../api/subscription.api';
import { getMySubscription } from '../api/subscription.api';

/**
 * The signed-in user's per-PDF caps, so a step can stop them *choosing* a number
 * the backend would only reject at generation time — after the upload and the
 * wait.
 *
 * A failed fetch stays `null` and leaves the field uncapped rather than guessing
 * a limit: `generateQuestions` enforces the same numbers server-side, so the
 * worst case is the late error we had before, never a bypass.
 */
export function usePlanLimits(): TierLimits | null {
  const [limits, setLimits] = useState<TierLimits | null>(null);

  useEffect(() => {
    let cancelled = false;
    getMySubscription()
      .then((sub) => {
        if (!cancelled) setLimits(sub.limits);
      })
      .catch(() => null);
    return () => {
      cancelled = true;
    };
  }, []);

  return limits;
}
